import GTM from '~/helpers/gtm'

export default {
  methods: {
    gtm (event, { price }, quantity, reserveData, facility) {
      const { salesManagoId = '' } = this.$store.state?.user?.profile

      this.$gtm.push({ ecommerce: null })
      this.$gtm.push(GTM.trackProductOnCartEvent(
        event,
        salesManagoId,
        this.product,
        quantity,
        price,
        this.isMediclubMember,
        reserveData,
        facility,
        null,
        this.$config.storeCode,
      ))
    },
  },
}
